// The rules the live pages use to turn a match's score into a projected outcome,
// shared by the Projected Combination (LivePoolItemWide) and the match rows
// (LiveMatchSummaryWide).

// "S6 V3 P1" -> "S6". The space must be there, as with the startsWith("S6 ") checks this replaced.
export const poolPrefix = (venue) => venue.substring(0, venue.indexOf(" "));

export const not_started = (match) =>
  match.match_status === "Not Started" || match.match_status === "Postponed" || match.match_status === "Cancelled" || match.match_status === "Field";

// A finished match's outcome is final (darkslateblue), a match in play is projected (tomato).
export const status_color = (match) => (match.match_status === "Finished" ? "darkslateblue" : "tomato");

// 1 home win, 2 draw, 3 away win.
export const std_outcome = (home, away) => {
  if (home > away) return 1;
  if (home === away) return 2;
  return 3;
};

// 1 or 2: home win by one or by more. 3 or 4: goalless or score draw. 5 or 6: away win by one or by more.
// Any other score has no outcome, and nothing is shown.
export const fourone_outcome = (home, away) => {
  if (home === away + 1) return 1;
  if (home > away + 1) return 2;
  if (home === away && home === 0) return 3;
  if (home === away && home > 0) return 4;
  if (away === home + 1) return 5;
  if (away > home + 1) return 6;
  return undefined;
};

// Soccer Scores: the score whichever side won. 8 is 0-0, 9 any other draw, 7 anything else.
const scores_outcomes = { "1-0": 1, "2-0": 2, "3-0": 3, "2-1": 4, "3-1": 5, "3-2": 6, "0-0": 8 };
export const scores_outcome = (home, away) => {
  const value = scores_outcomes[Math.max(home, away) + "-" + Math.min(home, away)];
  if (value !== undefined) return value;
  if (home === away && home > 0) return 9;
  return 7;
};
